export function Bullet() {
  return <span aria-hidden> &bull; </span>;
}
